import { useParams, useSearchParams } from 'react-router-dom';
import MaterialList from '../components/projects/MaterialList';
import { Container, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppContext } from '../contexts/AppContext';
import { useLang } from '../contexts/langContext';
import TagFilterChips from '../components/common/TagFilterChips';
import { useTags } from '../hooks/useTags';
import CopilotLauncher from '../components/copilot/CopilotLauncher';
import CopilotPanel from '../components/copilot/CopilotPanel';
import { useState as useReactState } from 'react';

function MaterialsPage() {
  const { id: projectId } = useParams();
  const { lang } = useLang();
  const { setAppTitle } = useAppContext();
  const [copilotOpen, setCopilotOpen] = useReactState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTagsParam = searchParams.get('tags');
  const initialSelectedTagIds = initialTagsParam ? initialTagsParam.split(',').filter(Boolean) : [];
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>(initialSelectedTagIds);
  const { tags } = useTags();
  const [tagCounts, setTagCounts] = useState<Record<string | 'all', number> | undefined>(undefined);

  useEffect(() => {
    setAppTitle(lang === 'en' ? 'Materials' : '素材');
  }, []);

  const handleCountsChange = (counts: Record<string | 'all', number>) => {
    setTagCounts(counts);
  };

  // Sync URL
  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    if (selectedTagIds.length === 0) {
      params.delete('tags');
    } else {
      params.set('tags', selectedTagIds.join(','));
    }
    setSearchParams(params, { replace: true });
  }, [selectedTagIds]);

  return (
    <Container maxWidth="md" sx={{ my: 2 }}>
      {/* Tag Filter Chips */}
      {tags.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <TagFilterChips
            tags={tags}
            selectedTagIds={selectedTagIds}
            onChange={setSelectedTagIds}
            tagCounts={tagCounts}
          />
        </Box>
      )}
      
      <MaterialList projectId={projectId} selectedTagIds={selectedTagIds} onCountsChange={handleCountsChange} />
      {!copilotOpen && <CopilotLauncher onOpen={() => setCopilotOpen(true)} />}
      <CopilotPanel
        open={copilotOpen}
        onClose={() => setCopilotOpen(false)}
        system={lang === 'en' ? 'You help users locate and compare materials and their status.' : '你帮助用户定位与比较素材及其状态。'}
        tools={['material_search', 'material_list', 'material_get', 'material_status']}
      />
    </Container>
  );
}

export default MaterialsPage;
